// extracted by mini-css-extract-plugin
export default {"field":"AddNotePanel_field__cYNwm"};